import styled from 'styled-components';

export const ContentContainer = styled.div`
  ${({ theme }) => theme.typography.xSmall}
  p {
    ${({ theme }) => theme.typography.xSmall}
  }
  p:last-child {
    margin-top: ${({ theme }) => theme.x4spacePx}px;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
`;
